import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { SERVICES } from "@/data";

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-24 md:py-36"
      style={{ backgroundColor: "var(--bg-secondary)" }}
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16">
          <Reveal>
            <p
              className="text-sm tracking-[0.28em] uppercase mb-5"
              style={{ color: "var(--rose-mocha-deep)" }}
            >
              What I Handle
            </p>
            <h2
              className="font-serif text-4xl md:text-5xl leading-tight tracking-tight max-w-xl"
              style={{ color: "var(--text-primary)" }}
            >
              Services curated to give your day back.
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p
              className="text-base md:text-lg max-w-sm leading-relaxed"
              style={{ color: "var(--text-secondary)" }}
            >
              Delegate the details. Every engagement is shaped around how you
              already work.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
          {SERVICES.map((s, i) => (
            <motion.div
              key={s.tag}
              data-testid={`service-card-${s.tag}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: (i % 4) * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className="group p-8 lg:p-10 transition-colors duration-500 hover:bg-[var(--bg-primary)]"
              style={{
                borderTop: "1px solid var(--border-light)",
                borderLeft:
                  i % 4 !== 0 ? "1px solid var(--border-light)" : "none",
              }}
            >
              <span
                className="font-serif text-lg"
                style={{ color: "var(--accent-gold)" }}
              >
                {s.tag}
              </span>
              <h3
                className="font-serif text-xl md:text-2xl mt-5 mb-3 tracking-tight transition-transform duration-500 group-hover:translate-x-1"
                style={{ color: "var(--text-primary)" }}
              >
                {s.title}
              </h3>
              <p
                className="text-sm md:text-base leading-relaxed"
                style={{ color: "var(--text-secondary)" }}
              >
                {s.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
